export const wordThree = [
  {
    id: 1,
    text: "Impartial",
    response: "Impartial observer makes great judge.",
  },
  {
    id: 2,
    text: "Nervous",
    response: "Listening to music help control nervousness.",
  },
  {
    id: 3,
    text: "Wife",
    response: "Martyrs' wives are strong-willed.",
  },
  {
    id: 4,
    text: "Gun",
    response: "Gun revolutionized the warfare.",
  },
  {
    id: 5,
    text: "Gratitude",
    response:
      "This country owes a debt of gratitude to those who died defending it.",
  },
  {
    id: 6,
    text: "Puzzle",
    response: "The Bermuda triangle has puzzled people with its mystery.",
  },
  {
    id: 7,
    text: "America",
    response: "America receives more immigrants than any other country",
  },
  {
    id: 8,
    text: "Beauty",
    response: "The natural beauty of Shimla is beyond compare.",
  },
  {
    id: 9,
    text: "Star",
    response: "Stars on the shoulders is the matter of great pride.",
  },
  {
    id: 10,
    text: "Kindness",
    response: "One must treat elders with kindness and respect.",
  },
  {
    id: 11,
    text: "Credit",
    response: "First credit card was introduced in 1950.",
  },
  {
    id: 12,
    text: "Quick",
    response: "There is no quick fix to life's problems.",
  },
  {
    id: 13,
    text: "Lonely",
    response: "An ideal and lonely mind tends to overthink.",
  },
  {
    id: 14,
    text: "Guide",
    response: "Past experiences are the guide to the future challenges.",
  },
  {
    id: 15,
    text: "Support",
    response: "A prosperous community tends to have individual support.",
  },
  {
    id: 16,
    text: "Readiness",
    response: "The soldier lay in readiness.",
  },
  {
    id: 17,
    text: "Blind",
    response: "Blind belief tampers logical thinking.",
  },
  {
    id: 18,
    text: "Fury",
    response: "Fury must be demonstrated in actions, not words.",
  },
  {
    id: 19,
    text: "Class",
    response: "Small business classes runs the economy.",
  },
  {
    id: 20,
    text: "Appearance",
    response: "One should not judge a man by his appearance.",
  },
  {
    id: 21,
    text: "Senior",
    response:
      "Senior citizen pension scheme was started under PM Vavya Vandana Yojana.",
  },
  {
    id: 22,
    text: "Strength",
    response: "One must be aware of their strengths and weaknesses.",
  },
  {
    id: 23,
    text: "Force",
    response: "Nuclear force is the strongest natural force.",
  },
  {
    id: 24,
    text: "Generosity",
    response:
      "Dr. APJ Abdul Kalam was admired for his simplicity and generosity of spirit.",
  },
  {
    id: 25,
    text: "God",
    response:
      "Saraswati is regarded as the goddess of knowledge in Hindu mythology.",
  },
  {
    id: 26,
    text: "Father",
    response: "Father is the backbone of a family.",
  },
  {
    id: 27,
    text: "Govern",
    response: "Governor of states and UTs are appointed by the president.",
  },
  {
    id: 28,
    text: "Censor",
    response: "Governments use limited censorship in Democracy.",
  },
  {
    id: 29,
    text: "Sense",
    response: "Humans have five sensory organ.",
  },
  {
    id: 30,
    text: "Limit",
    response: "All limitations are self-imposed.",
  },
  {
    id: 31,
    text: "Extra",
    response: "One must be willing to go an extra mile to achieve their goal.",
  },
  {
    id: 32,
    text: "Thief",
    response: "CCTV installation in public places will reduce thievery.",
  },
  {
    id: 33,
    text: "Cheerful",
    response: "One must have a cheerful and positive outlook on life.",
  },
  {
    id: 34,
    text: "Big",
    response: "The Big Bang theory explains the origin of the universe.",
  },
  {
    id: 35,
    text: "Noble",
    response: "Sardar Vallabhbhai Patel was the man of noble character.",
  },
  {
    id: 36,
    text: "Hunter",
    response: "A hunter should never lose patience.",
  },
  {
    id: 37,
    text: "Hint",
    response: "Icecap melting is a hint for increased global warming.",
  },
  {
    id: 38,
    text: "Reveal",
    response: "Actions reveal character.",
  },
  {
    id: 39,
    text: "Utilize",
    response: "Natural resources should be utilized wisely.",
  },
  {
    id: 40,
    text: "Heart",
    response: "Heart pumps about 2000 gallons of blood every day.",
  },
  {
    id: 41,
    text: "Virginity",
    response: "Virginity and sex should not be taboo in society.",
  },
  {
    id: 42,
    text: "Dog",
    response: "Dogs have strongest sensory organs.",
  },
  {
    id: 43,
    text: "Invest",
    response: "Time invested in self improves personality.",
  },
  {
    id: 44,
    text: "Fast",
    response: "Falcon is the fastest bird in the world.",
  },
  {
    id: 45,
    text: "Foreign",
    response: "Foreign investment promotes capitalization.",
  },
  {
    id: 46,
    text: "Master",
    response: "Patience is the key to mastering any skill.",
  },
  {
    id: 47,
    text: "Firing",
    response: "Soldiers are never far behind the firing line.",
  },
  {
    id: 48,
    text: "Water",
    response: "Water regulates the Earth’s temperature..",
  },
  {
    id: 49,
    text: "Laughter",
    response: "Laughter is the best therapy.",
  },
  {
    id: 50,
    text: "Contrary",
    response: "Going over the speed limit is contrary to traffic laws.",
  },
  {
    id: 51,
    text: "Past",
    response: "Revisiting happy memories of the past evokes nostalgia.",
  },
  {
    id: 52,
    text: "President",
    response: "President is the first citizen.",
  },
  {
    id: 53,
    text: "Lead",
    response: "The people need to elect a leader they can trust.",
  },
  {
    id: 54,
    text: "Desperate",
    response: "Some situations call for desperate measures.",
  },
  {
    id: 55,
    text: "Lost",
    response: "Trust once lost cannot be regained.",
  },
  {
    id: 56,
    text: "Election",
    response: "The election reflects the will of the people.",
  },
  {
    id: 57,
    text: "Play",
    response: "It's the player's responsibility to uphold the spirit.",
  },
  {
    id: 58,
    text: "Unable",
    response:
      "Physically unable people should receive normal treatment in society.",
  },
  {
    id: 59,
    text: "Sunset",
    response: "Sunset and sunrise are the epitom of natural beauty.",
  },
  {
    id: 60,
    text: "Feeling",
    response: "One must learn to express their feelings.",
  },
];
